import { render, staticRenderFns } from "./DashboardRecentPlacementsTableItem.vue?vue&type=template&id=1450e06d"
import script from "./DashboardRecentPlacementsTableItem.vue?vue&type=script&lang=js"
export * from "./DashboardRecentPlacementsTableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports